import LoadingSpinner from "@/components/LoadingSpinner";

export const SigningInWelcomeCard = () => (
  <div className="flex min-h-[500px] items-center justify-center">
    <div className="w-full max-w-md rounded-3xl bg-white p-12 text-center">
      <span className="mb-4 text-xl font-bold leading-tight text-gray-900">
        Welcome to PromptLayer!
      </span>
      <p className="mt-2 text-lg text-gray-600">Logging in..</p>
      <div className="mt-4 flex items-center justify-center">
        <LoadingSpinner />
      </div>
    </div>
  </div>
);
